import { render } from "./ToDoListAddPhaseModal.vue?vue&type=template&id=9b07fac8&ts=true"
import script from "./ToDoListAddPhaseModal.vue?vue&type=script&lang=ts"
export * from "./ToDoListAddPhaseModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__